import { Component, OnInit } from '@angular/core';
import { ModalController, NavController, AlertController, LoadingController } from '@ionic/angular';
import { Router } from '@angular/router';

import { SportLeague } from 'src/core/models';
import {
  AgeGroupService, ArrayService, AuthService, ChurchService, DatabaseService, 
  DocumentService, LeagueService, SportTeamService, FestivalUserService 
} from 'src/core/services';
import { AddLeagueComponent } from '../add-league/add-league.component';
import { EditLeagueComponent } from '../edit-league/edit-league.component';
import { Sport, Gender } from 'src/core/enums';
import { PageClass } from 'src/core/classes/page';

@Component({
  selector: 'app-league-list',
  templateUrl: './league-list.component.html',
  styleUrls: ['./league-list.component.less', '../../core/styles/common.less']
})

export class LeagueListComponent extends PageClass implements OnInit {

  leagueList: SportLeague[] = [];
  sportList: any[];

  filter: any = { filterSport: undefined };

  isLoading = true;

  constructor(
    protected ageGroupService: AgeGroupService,
    protected arrayService: ArrayService,
    protected authService: AuthService,
    protected churchService: ChurchService,
    protected databaseService: DatabaseService,
    private docService: DocumentService,
    private router: Router,
    private leagueService: LeagueService,
    private sportTeamService: SportTeamService,
    protected festivalUserService: FestivalUserService,
    protected navController: NavController,
    protected modalController: ModalController,
    protected alertController: AlertController,
    protected loadingController: LoadingController
  ) { 
    super(ageGroupService, arrayService, authService, churchService, databaseService, festivalUserService);
  }

  protected loadData = async () => {
    this.currentUser = this.festivalUserService.GetCurrentFestivalUser();
    if (this.currentUser.isActive && !this.currentUser.isDeleted) {
      if (!this.currentUser.isAdmin) {
        this.router.navigate(['/']);
      } else {
        this.sportList = this.sportTeamService.getSportList();
        
        this.filter.filterSport = localStorage.getItem('filteredSport') ? 
          this.sportList.find(s => s.value == localStorage.getItem('filteredSport')).value : 
          this.sportList[0].value;

        this.getLeagueList();
      }
    }
  }

  async getLeagueList() {
    localStorage.setItem('filteredSport', this.filter.filterSport);

    this.leagueService.getLeagueList(this.filter.filterSport)
      .subscribe(leagueList => {
        this.leagueList = leagueList.sort(this.arrayService.orderByDisplayName);

        this.leagueList.forEach(league => {
          league.sportName = Sport[league.sport];

          if (!league.isMixedGender && league.gender) {
            league.genderName = Gender[league.gender];
          } else {
            league.genderName = 'Mixed';
          }
        });

        this.isLoading = false;
      });
  }

  doRefresh = async (event) => {
    await this.loadData();
    event.target.complete();
  }

  public async addLeague() {
    const modal = await this.modalController.create({
      component: AddLeagueComponent,
      componentProps: {
      }
    });
    return await modal.present();
  }

  public async editLeague (league: SportLeague) {
    const modal = await this.modalController.create({
      component: EditLeagueComponent,
      componentProps: {
        league
      }
    });
    return await modal.present();
  }

  deleteLeague = (leagueId: string) => {
    this.docService.deleteDocument('sportLeagues', leagueId);
  }
}
